import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const MAIN_FONT = "Noto Sans TC";
const MENU_CAPTION_FONT_SIZE = 20;

/**
 * LeaderboardSideMenu — vertical sidebar menu for the full-screen leaderboard page.
 *
 * Props:
 *   leaderboards  {Array<{ label: string, type: string, orgType: string }>}
 *   currentIndex  {number}
 *   onSelect      {(index: number) => void}
 *   onBack        {() => void}
 */
export default function LeaderboardSideMenu({ leaderboards, currentIndex, onSelect, onBack }) {
    return (
        <>
            {/* Section header */}
            <Typography
                sx={{
                    fontFamily: MAIN_FONT,
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "rgba(180, 160, 220, 0.5)",
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    px: 2,
                    pt: 2.5,
                    pb: 1,
                    userSelect: "none",
                }}
            >
                排行榜
            </Typography>

            {/* Menu items */}
            <Box sx={{ flex: 1, overflowY: "auto" }}>
                {leaderboards.map((lb, index) => {
                    const isActive = index === currentIndex;
                    return (
                        <Box
                            key={index}
                            onClick={() => onSelect(index)}
                            sx={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                px: 2,
                                py: 1.25,
                                cursor: "pointer",
                                background: isActive
                                    ? "linear-gradient(90deg, rgba(130,60,255,0.2) 0%, transparent 100%)"
                                    : "transparent",
                                transition: "background 0.2s",
                                "&:hover": {
                                    background: isActive
                                        ? "linear-gradient(90deg, rgba(130,60,255,0.25) 0%, transparent 100%)"
                                        : "linear-gradient(90deg, rgba(130,60,255,0.1) 0%, transparent 100%)",
                                },
                            }}
                        >
                            {/* Active indicator bar */}
                            {isActive && (
                                <Box
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        top: "15%",
                                        width: "3px",
                                        height: "70%",
                                        background: "linear-gradient(180deg, #00FF88, #00E5FF)",
                                        borderRadius: "0 3px 3px 0",
                                        boxShadow: "0 0 8px rgba(0, 229, 255, 0.8)",
                                    }}
                                />
                            )}
                            <Typography
                                sx={{
                                    fontFamily: MAIN_FONT,
                                    fontSize: `${MENU_CAPTION_FONT_SIZE}px`,
                                    fontWeight: isActive ? "700" : "400",
                                    color: isActive ? "#00E5FF" : "rgba(180, 160, 220, 0.7)",
                                    textShadow: isActive
                                        ? "0 0 8px rgba(0, 229, 255, 0.5)"
                                        : "none",
                                    transition: "color 0.2s",
                                    userSelect: "none",
                                    lineHeight: 1.4,
                                }}
                            >
                                {lb.label}
                            </Typography>
                        </Box>
                    );
                })}

                {/* Back to Main */}
                <Divider sx={{ borderColor: "rgba(130, 60, 255, 0.3)", mx: 2, my: 1 }} />
                <Box
                    onClick={onBack}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        px: 2,
                        py: 1.25,
                        cursor: "pointer",
                        transition: "background 0.2s",
                        "&:hover": {
                            background:
                                "linear-gradient(90deg, rgba(130,60,255,0.1) 0%, transparent 100%)",
                        },
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: MAIN_FONT,
                            	
                            fontWeight: "400",
                            color: "rgba(180, 160, 220, 0.5)",
                            userSelect: "none",
                            transition: "color 0.2s",
                            "&:hover": { color: "rgba(180, 160, 220, 0.9)" },
                        }}
                    >
                        ← 返回主頁
                    </Typography>
                </Box>
            </Box>
        </>
    );
}
